import { Alert, Text } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { erroDaGestao, lerVersaoDoExecutor, type ClusterCloudHsm } from '@/api/cloudhsm'

/**
 * Versão do executor de CloudHSM da conta contra a imagem do catálogo (consoleai#26390).
 *
 * Executor numa versão anterior: faixa "executor na versão X, a atual é Y". Sem botão — a
 * atualização pela tela é a D2. Versão que não foi lida não vira "igual": a falha aparece como
 * falha.
 */
export function VersaoDoExecutor({ tenantId, cluster }: { tenantId: number; cluster: ClusterCloudHsm }) {
  const q = useQuery({
    queryKey: ['cloudhsm', 'executor', tenantId, cluster.regiao, cluster.cluster_id],
    queryFn: () => lerVersaoDoExecutor(tenantId, cluster.cluster_id, cluster.regiao),
    retry: false,
    staleTime: 5 * 60_000,
  })

  if (q.isError) {
    return (
      <Text size="xs" c="dimmed">
        Versão do executor não lida: {erroDaGestao(q.error, 'falha ao consultar o executor')}
      </Text>
    )
  }
  const v = q.data
  if (!v) return null
  if (v.situacao === 'ausente') {
    return (
      <Text size="xs" c="dimmed">
        Esta conta não tem o executor do CloudHSM em {cluster.regiao}: a gestão de usuários e chaves
        depende dele.
      </Text>
    )
  }
  if (v.situacao === 'antiga') {
    return (
      <Alert color="yellow" variant="light" icon={<IconAlertTriangle size={16} />} title="Executor desatualizado">
        Executor na versão {v.versao_atual}, a atual é {v.versao_esperada}.
      </Alert>
    )
  }
  return (
    <Text size="xs" c="dimmed">
      {v.situacao === 'igual'
        ? `Executor na versão ${v.versao_atual}, a atual.`
        : `Executor na versão ${v.versao_atual}, posterior à do catálogo (${v.versao_esperada}).`}
    </Text>
  )
}
